import { render, staticRenderFns } from "./Bubuia.vue?vue&type=template&id=72b732ce&scoped=true&"
import script from "./Bubuia.vue?vue&type=script&lang=js&"
export * from "./Bubuia.vue?vue&type=script&lang=js&"
import style0 from "./Bubuia.vue?vue&type=style&index=0&id=72b732ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b732ce",
  null
  
)

export default component.exports